import { type Html, html, rune, View } from 'rune-ts';
import klass from './RecruitSection.module.scss';
import { font } from '../../../../../shared/typography';
import { BlinkIcon, DotIcon } from '../../../../../shared/components/atoms/Icon/foundation_icons';
import { media_url_info } from '../../constant';

export class RecruitSection extends View {
  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const texts = {
      sub_title: '커머스 크리에이터 모집',
      requirement: is_mobile
        ? html.preventEscape(`인스타그램, 유튜브 채널, 틱톡 중 <br/>하나 이상 보유`)
        : '인스타그램, 유튜브 채널, 틱톡 중 하나 이상 보유',
    };
    return html` <section class="${klass.recruit}">
      <div class="${klass.main_content}">
        <div class="${klass.title}">
          <div class="${font('24_bold', '16_bold')}">지금 신청하면 판매 수수료 전액 면제</div>
          <div class="${font('48_bold', '28_bold')}">${texts.sub_title}</div>
        </div>
        <div class="${klass.info_list}">
          <div class="${klass.info_item}">
            <div class="${font('20_bold')} ${klass.info_title}">
              ${BlinkIcon({ klass: klass.blink_icon })}
              <span>모집 안내</span>
            </div>
            <div class="${klass.sub_info_list} ${font('20_bold', '14_bold')}">
              <div class="${klass.sub_info_item}">
                <p class="${klass.item_title} ${font('16_bold', '14_bold')}">모집기간</p>
                <p class="${klass.item_desc}">2025년 5월 14일(수) ~ 마감 전</p>
              </div>
              <div class="${klass.sub_info_item}">
                <p class="${klass.item_title} ${font('16_bold', '14_bold')}">대상자 발표</p>
                <p class="${klass.item_desc}">추후 별도 연락</p>
              </div>
              <div class="${klass.sub_info_item}">
                <p class="${klass.item_title} ${font('16_bold', '14_bold')}">지원 방법</p>
                <p class="${klass.item_desc} ${klass.flow}">
                  <span class="${klass.arrow_icon_wrapper}">커머스 크리에이터 지원하기 →</span>
                  <span>지원서 작성 후 제출</span>
                </p>
              </div>
            </div>
          </div>
          <div class="${klass.info_item}">
            <div class="${font('20_bold')} ${klass.info_title}">
              ${BlinkIcon({ klass: klass.blink_icon })}
              <span>지원 자격</span>
            </div>
            <div class="${klass.sub_info_list} ${font('20_bold', '14_bold')}">
              <div class="${klass.sub_info_item}">
                <p class="${klass.item_title} ${font('16_bold', '14_bold')}">필수 조건</p>
                <div class="${klass.item_desc} ${klass.requirement}">
                  <p>${texts.requirement}</p>
                  <div class="${klass.requirement_list}">
                    <div class="${klass.requirement_item}">
                      ${DotIcon({ klass: klass.dot })}인스타그램 팔로워 10,000명 이상
                    </div>
                    <div class="${klass.requirement_item}">
                      ${DotIcon({ klass: klass.dot })}유튜브 구독자 5,000명 이상
                    </div>
                    <div class="${klass.requirement_item}">
                      ${DotIcon({ klass: klass.dot })}틱톡 팔로워 100,000명 이상
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="${klass.commerce_creator_ad}">
        <div class="${klass.video_wrapper}">
          <video
            autoplay=""
            loop=""
            muted=""
            playsinline=""
            class="${klass.motion_video}"
            src="${media_url_info.recruit_section.video}"
          ></video>
        </div>
      </div>
    </section>`;
  }
}
